import { motion } from 'framer-motion';
import { useAdminStore } from '../../store/adminStore';
import './AdminSidebar.css';

const navItems = [
    { id: 'dashboard' as const, icon: '📊', label: 'Dashboard' },
    { id: 'orders' as const, icon: '📦', label: 'Orders' },
    { id: 'transactions' as const, icon: '💸', label: 'Transactions' },
    { id: 'wallets' as const, icon: '👛', label: 'Wallets' },
    { id: 'settings' as const, icon: '⚙️', label: 'Settings' },
];

export default function AdminSidebar() {
    const activePanel = useAdminStore(state => state.activePanel);
    const setActivePanel = useAdminStore(state => state.setActivePanel);
    const logout = useAdminStore(state => state.logout);

    return (
        <div className="admin-sidebar glass">
            <div className="sidebar-header">
                <div className="sidebar-logo">⚡</div>
                <h2 className="sidebar-title">Ghost-Flash</h2>
                <p className="sidebar-subtitle">Admin Panel</p>
            </div>

            <nav className="sidebar-nav">
                {navItems.map((item) => (
                    <motion.button
                        key={item.id}
                        className={`nav-item ${activePanel === item.id ? 'active' : ''}`}
                        onClick={() => setActivePanel(item.id)}
                        whileHover={{ x: 5 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <span className="nav-icon">{item.icon}</span>
                        <span className="nav-label">{item.label}</span>
                        {activePanel === item.id && (
                            <motion.div
                                className="nav-indicator"
                                layoutId="activeIndicator"
                                transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                            />
                        )}
                    </motion.button>
                ))}
            </nav>

            <div className="sidebar-footer">
                <motion.button
                    className="logout-btn"
                    onClick={logout}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    <span className="nav-icon">🚪</span>
                    <span className="nav-label">Logout</span>
                </motion.button>
            </div>
        </div>
    );
}
